/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
type Developments_root$ref = any;
type Layout_pageWithData$ref = any;
type Layout_root$ref = any;
type PageMeta_root$ref = any;
export type DevelopmentProductFiltersPage = {|
  number: number,
  count: number,
|};
export type DevelopmentProductFilters = {|
  search?: ?string,
  properties_locality_in?: ?$ReadOnlyArray<?string>,
  properties_state_in?: ?$ReadOnlyArray<?string>,
  host?: ?string,
|};
export type developmentsQueryVariables = {|
  sortBy?: ?string,
  sortDirection?: ?string,
  page?: ?DevelopmentProductFiltersPage,
  filters?: ?DevelopmentProductFilters,
  uid: string,
  lang: string,
|};
export type developmentsQueryResponse = {|
  +cms: {|
    +pageWithData: ?{|
      +$fragmentRefs: Layout_pageWithData$ref
    |}
  |},
  +$fragmentRefs: Layout_root$ref & Developments_root$ref & PageMeta_root$ref,
|};
export type developmentsQuery = {|
  variables: developmentsQueryVariables,
  response: developmentsQueryResponse,
|};
*/


/*
query developmentsQuery(
  $sortBy: String
  $sortDirection: String
  $page: DevelopmentProductFiltersPage
  $filters: DevelopmentProductFilters
  $uid: String!
  $lang: String!
) {
  ...Layout_root_3iqx2P
  ...Developments_root
  ...PageMeta_root
  cms {
    pageWithData(uid: $uid, lang: $lang) {
      ...Layout_pageWithData
    }
  }
}

fragment Breadcrumbs_hierarchy on CMSPage {
  template
  link_title
  custom_path
  _meta {
    uid
  }
}

fragment DevelopmentSummary_development on DevelopmentProduct {
  title
  deliveryDate
  slug
  developer {
    name
    id
  }
  broker {
    organisation {
      name
      id
    }
    id
  }
  developmentImages {
    size
    crop
    displayOnListing
    backgroundColor
    image {
      url
      id
    }
    id
  }
  aggregates {
    productsCount
    activeProductsCount
    minSalePrice
    minNumberOfBedrooms
    maxNumberOfBedrooms
    postcode
    locality
  }
}

fragment Developments_root on Query {
  ...LocationFilter_root
  developmentProducts(page: $page, sortBy: $sortBy, sortDirection: $sortDirection, filters: $filters) {
    totalCount
    edges {
      node {
        ...DevelopmentSummary_development
        id
      }
    }
  }
}

fragment Layout_pageWithData on CMSPageWithData {
  hierarchy {
    ...Breadcrumbs_hierarchy
  }
  page {
    template
    canonical_url {
      __typename
      ... on CMS_ExternalLink {
        url
      }
      ... on CMSPage {
        _meta {
          uid
          lang
        }
      }
    }
    meta_robots
    show_phone
    _meta {
      id
      lang
      alternateLanguages {
        uid
        lang
        id
      }
    }
  }
}

fragment Layout_root_3iqx2P on Query {
  cms {
    navigation(uid: "main", lang: $lang) {
      nav_logo_link {
        __typename
        ... on CMSPage {
          template
          _meta {
            uid
            lang
          }
        }
      }
      phone_number
      body {
        __typename
        ... on CMSNavigationBodyNavigation_item {
          primary {
            label
            pathname
            nav_link {
              __typename
              ... on CMSPage {
                template
                _meta {
                  id
                  uid
                  lang
                }
              }
            }
          }
          fields {
            label
            pathname
            sub_nav_link {
              __typename
              ... on CMSPage {
                template
                _meta {
                  uid
                  lang
                }
              }
            }
          }
        }
      }
    }
    footerNavigation: navigation(uid: "footer", lang: $lang) {
      phone_number
    }
  }
}

fragment LocationFilter_root on Query {
  developmentProductInfo {
    states {
      state
      developmentsCount
    }
  }
}

fragment PageMeta_root on Query {
  cms {
    pageWithData(uid: $uid, lang: $lang) {
      page {
        title
        description
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lang"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "page"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortBy"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortDirection"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uid"
},
v6 = {
  "kind": "Variable",
  "name": "lang",
  "variableName": "lang"
},
v7 = [
  (v6/*: any*/),
  {
    "kind": "Variable",
    "name": "uid",
    "variableName": "uid"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "template",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uid",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lang",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "CMSMeta",
  "kind": "LinkedField",
  "name": "_meta",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v11/*: any*/)
  ],
  "storageKey": null
},
v13 = [
  (v8/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v9/*: any*/),
      (v12/*: any*/)
    ],
    "type": "CMSPage",
    "abstractKey": null
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phone_number",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pathname",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v20 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  (v17/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "developmentsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CMS",
        "kind": "LinkedField",
        "name": "cms",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "CMSPageWithData",
            "kind": "LinkedField",
            "name": "pageWithData",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "Layout_pageWithData"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "args": [
          (v6/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "Layout_root"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "Developments_root"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "PageMeta_root"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "developmentsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CMS",
        "kind": "LinkedField",
        "name": "cms",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              (v6/*: any*/),
              {
                "kind": "Literal",
                "name": "uid",
                "value": "main"
              }
            ],
            "concreteType": "CMSNavigation",
            "kind": "LinkedField",
            "name": "navigation",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "nav_logo_link",
                "plural": false,
                "selections": (v13/*: any*/),
                "storageKey": null
              },
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "body",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CMSNavigationBodyNavigation_itemPrimary",
                        "kind": "LinkedField",
                        "name": "primary",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "nav_link",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CMSMeta",
                                    "kind": "LinkedField",
                                    "name": "_meta",
                                    "plural": false,
                                    "selections": [
                                      (v17/*: any*/),
                                      (v10/*: any*/),
                                      (v11/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "CMSPage",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CMSNavigationBodyNavigation_itemFields",
                        "kind": "LinkedField",
                        "name": "fields",
                        "plural": true,
                        "selections": [
                          (v15/*: any*/),
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "sub_nav_link",
                            "plural": false,
                            "selections": (v13/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "CMSNavigationBodyNavigation_item",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "footerNavigation",
            "args": [
              (v6/*: any*/),
              {
                "kind": "Literal",
                "name": "uid",
                "value": "footer"
              }
            ],
            "concreteType": "CMSNavigation",
            "kind": "LinkedField",
            "name": "navigation",
            "plural": false,
            "selections": [
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "CMSPageWithData",
            "kind": "LinkedField",
            "name": "pageWithData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CMSPage",
                "kind": "LinkedField",
                "name": "page",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "canonical_url",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v19/*: any*/)
                        ],
                        "type": "CMS_ExternalLink",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v12/*: any*/)
                        ],
                        "type": "CMSPage",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meta_robots",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "show_phone",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CMSMeta",
                    "kind": "LinkedField",
                    "name": "_meta",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CMSRelatedDocument",
                        "kind": "LinkedField",
                        "name": "alternateLanguages",
                        "plural": true,
                        "selections": [
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v17/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CMSPage",
                "kind": "LinkedField",
                "name": "hierarchy",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "link_title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "custom_path",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CMSMeta",
                    "kind": "LinkedField",
                    "name": "_meta",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DevelopmentProductInfo",
        "kind": "LinkedField",
        "name": "developmentProductInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DevelopmentState",
            "kind": "LinkedField",
            "name": "states",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "developmentsCount",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
          },
          {
            "kind": "Variable",
            "name": "page",
            "variableName": "page"
          },
          {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
          },
          {
            "kind": "Variable",
            "name": "sortDirection",
            "variableName": "sortDirection"
          }
        ],
        "concreteType": "DevelopmentProductConnectionConnection",
        "kind": "LinkedField",
        "name": "developmentProducts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DevelopmentProductConnectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DevelopmentProduct",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deliveryDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organisation",
                    "kind": "LinkedField",
                    "name": "developer",
                    "plural": false,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "broker",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Organisation",
                        "kind": "LinkedField",
                        "name": "organisation",
                        "plural": false,
                        "selections": (v20/*: any*/),
                        "storageKey": null
                      },
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DevelopmentImage",
                    "kind": "LinkedField",
                    "name": "developmentImages",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "size",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "crop",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayOnListing",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "backgroundColor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "image",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v17/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DevelopmentProductAggregates",
                    "kind": "LinkedField",
                    "name": "aggregates",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "productsCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "activeProductsCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "minSalePrice",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "minNumberOfBedrooms",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "maxNumberOfBedrooms",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "postcode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "locality",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v17/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1a42741a8060e024a280195e73f14475",
    "id": null,
    "metadata": {},
    "name": "developmentsQuery",
    "operationKind": "query",
    "text": "query developmentsQuery(\n  $sortBy: String\n  $sortDirection: String\n  $page: DevelopmentProductFiltersPage\n  $filters: DevelopmentProductFilters\n  $uid: String!\n  $lang: String!\n) {\n  ...Layout_root_3iqx2P\n  ...Developments_root\n  ...PageMeta_root\n  cms {\n    pageWithData(uid: $uid, lang: $lang) {\n      ...Layout_pageWithData\n    }\n  }\n}\n\nfragment Breadcrumbs_hierarchy on CMSPage {\n  template\n  link_title\n  custom_path\n  _meta {\n    uid\n  }\n}\n\nfragment DevelopmentSummary_development on DevelopmentProduct {\n  title\n  deliveryDate\n  slug\n  developer {\n    name\n    id\n  }\n  broker {\n    organisation {\n      name\n      id\n    }\n    id\n  }\n  developmentImages {\n    size\n    crop\n    displayOnListing\n    backgroundColor\n    image {\n      url\n      id\n    }\n    id\n  }\n  aggregates {\n    productsCount\n    activeProductsCount\n    minSalePrice\n    minNumberOfBedrooms\n    maxNumberOfBedrooms\n    postcode\n    locality\n  }\n}\n\nfragment Developments_root on Query {\n  ...LocationFilter_root\n  developmentProducts(page: $page, sortBy: $sortBy, sortDirection: $sortDirection, filters: $filters) {\n    totalCount\n    edges {\n      node {\n        ...DevelopmentSummary_development\n        id\n      }\n    }\n  }\n}\n\nfragment Layout_pageWithData on CMSPageWithData {\n  hierarchy {\n    ...Breadcrumbs_hierarchy\n  }\n  page {\n    template\n    canonical_url {\n      __typename\n      ... on CMS_ExternalLink {\n        url\n      }\n      ... on CMSPage {\n        _meta {\n          uid\n          lang\n        }\n      }\n    }\n    meta_robots\n    show_phone\n    _meta {\n      id\n      lang\n      alternateLanguages {\n        uid\n        lang\n        id\n      }\n    }\n  }\n}\n\nfragment Layout_root_3iqx2P on Query {\n  cms {\n    navigation(uid: \"main\", lang: $lang) {\n      nav_logo_link {\n        __typename\n        ... on CMSPage {\n          template\n          _meta {\n            uid\n            lang\n          }\n        }\n      }\n      phone_number\n      body {\n        __typename\n        ... on CMSNavigationBodyNavigation_item {\n          primary {\n            label\n            pathname\n            nav_link {\n              __typename\n              ... on CMSPage {\n                template\n                _meta {\n                  id\n                  uid\n                  lang\n                }\n              }\n            }\n          }\n          fields {\n            label\n            pathname\n            sub_nav_link {\n              __typename\n              ... on CMSPage {\n                template\n                _meta {\n                  uid\n                  lang\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    footerNavigation: navigation(uid: \"footer\", lang: $lang) {\n      phone_number\n    }\n  }\n}\n\nfragment LocationFilter_root on Query {\n  developmentProductInfo {\n    states {\n      state\n      developmentsCount\n    }\n  }\n}\n\nfragment PageMeta_root on Query {\n  cms {\n    pageWithData(uid: $uid, lang: $lang) {\n      page {\n        title\n        description\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '736d786daa9a6ac6814b2b26604dda82';

export default node;
